import { render, staticRenderFns } from "./CategoryMaterials.vue?vue&type=template&id=2101c9a6&scoped=true&"
import script from "./CategoryMaterials.vue?vue&type=script&lang=js&"
export * from "./CategoryMaterials.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMaterials.vue?vue&type=style&index=0&id=2101c9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2101c9a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardTitle,VDataTable,VDivider,VIcon,VSpacer,VTextField,VTextarea})
